const defaultData = {
  documentNumber: '',
  idCommerce: '',
  commercialName: '',
  merchantIdCardnet: '',
  cardnetTerminalId: '',
  expirationDays: 7,
  activePaymentLinks: true,
  mcc: '',
  checkedItbis: false,
  threeDSKey: ''
};

export default defaultData;

// 3f2504e0-4f89-41d3-9a0c-0305e82c3301